export const fullNameFirstLetter = (firstName, lastName) => {
  const firstChar = firstName?.[0]
  const lastChar = lastName?.[0];
  return `${firstChar}${lastChar}`;
};
